function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "times");

var _ref2 = /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "2-20");

function SvgIcn220Times({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(6.34 35.95)",
    style: {
      fontSize: 10,
      fill: "#5e5e5d",
      fontFamily: "Inter",
      fontWeight: 700
    }
  }, _ref), /*#__PURE__*/React.createElement("text", {
    "data-name": "2-20",
    transform: "translate(5.5 20.63)",
    style: {
      fontSize: 12,
      fill: "#5e5e5d",
      fontFamily: "Inter",
      fontWeight: 700
    }
  }, _ref2)));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn220Times);
export default __webpack_public_path__ + "static/media/icn-2-20-times.8d321930c60e73db8b1760923fef7e48.svg";
export { ForwardRef as ReactComponent };